import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts';
import './styles/globals.css';
import { initPWA } from '@/lib/pwa';

// Initialize PWA (after ReactDOM.createRoot)
initPWA();

// Initialize Firebase (import for side effects)
import './firebase/config';

// Initialize telemetry (listens to auth state)
import { bootstrapTelemetry } from '@/services/telemetry/telemetry-bootstrap';
bootstrapTelemetry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register PWA service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.log('SW registration failed:', error);
    });
  });
}
